/**
 * @file advanced_report Page
 * @author zhenglujie(zhenglujie@baidu.com))
 * Copyright (c) 2019-06-29 Baidu
 */

import React from 'react';
import {connect} from 'react-redux';
import {Table} from 'antd';
import {advancedReport} from '../../common/package';
import img1 from '../../img/dwz-250424-1.png';
import img2 from '../../img/dwz-250424-4.png';
import img3 from '../../img/dwz-250424-5.png';
import img4 from '../../img/dwz-250424-6.png';

import './index.less';

class Senior extends React.Component {
    render() {
        const conceptDataSource = [
            {
              key: '1',
              name: '浏览量（PV）',
              jump: '用户每访问一个短网址记录1次。用户多次访问同一个短网址，浏览量值累计。',
              create: '用户为一个长链接生成一个短网址，记录1次。用户多次为一个长链接生成短网址，浏览量值累计。',
            },
            {
              key: '2',
              name: '访客量（UV）',
              jump: '指定时间内，您短网址的独立访客数（以Cookie为依据），同一访客多次访问您短网址只计算1个访客。',
              create: '指定时间内，创建短网址的独立创建者数量（以Cookie为依据）。',
            },
          ];
        const conceptColumns = [
            {
              title: '',
              dataIndex: 'name',
              key: 'name',
              width: 100
            },
            {
              title: '短网址跳转',
              dataIndex: 'jump',
              key: 'jump',
              width: 220
            },
            {
              title: '短网址创建',
              dataIndex: 'create',
              key: 'create',
              width: 220
            },
        ];
        const jumpDataSource = [
            {
              key: '1',
              msg: '访问趋势',
              details:'浏览次数（PV)'
            },
            {
              key: '2',
              msg: '访问明细',
              details:'了解流量来源的ip、城市、省份、referer（来源）、UA标识等。'
            },
        ];
        const jumpColumns = [
            {
              title: '',
              dataIndex: 'msg',
              key: 'msg',
            },
            {
              title: '说明',
              dataIndex: 'details',
              key: 'details',
            },
        ];
        const jumpIntroduce ='您的长网址缩短为短网址下发推广后，高级报表为您提供以下维度的统计分析，'
            + '帮助您了解不同时间段内，用户访问的情况，为您后续的优化、推广策略调整提供数据依据。'
        const jumpExplain = '【跳转】说明：终端用户点击短网址，访问短网址的动作，称为“跳转”。例如：'
            + '点击短信中所附短网址链接、扫描短网址对应的二维码等。'
        return (
            <div className="senior-container">
                <div style={{margin:'0 0 50px 30px'}}>
                    <div style={{width:'100%',paddingTop:'20px'}}>
                        <h2 className="title">开通流程</h2>
                    </div>
                    <ol>
                        <li>点击“立即购买高级报表”。</li>
                        <li>点击“统计查询”-“统计”了解访问趋势和访问明细。</li>
                    </ol>
                    <div className="senior-img">
                        <img src={img1}/>
                    </div>
                    <div className="senior-img">
                        <img src={img4}/>
                    </div>
                    <div style={{width:'100%',paddingTop:'20px'}}>
                        <h2 className="title">基本概念</h2>
                    </div>
                    <Table dataSource={conceptDataSource} columns={conceptColumns} bordered={true} pagination={false} />
                    <h3>说明:</h3>
                    <ol>
                        <li>
                            {jumpExplain}
                            <br/>
                            【创建】将长网址缩短为短网址，称为“创建”。
                        </li>
                    </ol>
                    <div style={{width:'100%',paddingTop:'20px'}}>
                        <h2 className="title">跳转相关的数据统计</h2>
                    </div>
                    <p>{jumpIntroduce}</p>
                    <Table dataSource={jumpDataSource} columns={jumpColumns} bordered={true} pagination={false} />
                    <div className="senior-img">
                        <img src={img2}/>
                    </div>
                    <div className="senior-img">
                        <img src={img3}/>
                    </div>
                    <div style={{width:'100%',paddingTop:'20px'}}>
                        <h2 className="title">付费说明</h2>
                    </div>
                    <p>高级报表为百度短网址的特色增值服务，为您提供用户数据统计分析，帮助您用数据驱动业务增长，提高转化率。</p>
                    {/* 高级报表 */}
                    <Table columns={advancedReport.head}
                        dataSource={advancedReport.body}
                        pagination={false} bordered={true} />
                    <p>高级报表暂不支持退款；为方便用户使用，您可以提
                        <a
                            target="_blank"
                            href="https://console.bce.baidu.com/ticket/?_=1700103019656/#/ticket/create?productId=188&questionId=706&createDirectly=1"
                        >工单</a>咨询详情。
                    </p>
                </div>
            </div>
        );
    }
}
export default connect(state => ({
    currentPage: state.currentPage
}))(Senior);
